import type { TipologiaImpianto } from '@praticheenergia/domain'

export const ETICHETTA_TIPOLOGIA: Record<TipologiaImpianto, string> = {
  cessione_parziale_esente: 'Cessione Parziale Esente da Accisa',
  cessione_parziale_commerciale: 'Cessione Parziale Commerciale',
  cessione_totale: 'Cessione Totale',
  altre_officine: 'Altre officine',
  impianto_vendita: 'Impianto di vendita',
  non_configurato: 'Non ancora configurato',
}
